export const LOADED = 'question-game/valentine/LOADED'
export const LOADING = 'question-game/valentine/LOADING'
